export default "__VITE_ASSET__BtvadCVc__"